// <s-signup-popup> opens the newsletter discount dialog once per visitor after a short delay.
// Server-rendered feedback (success/errors) forces it open via the open-now attribute.
const STORAGE_KEY = 'rainstar-signup-popup';
const SUPPRESS_DAYS = 7;

class SSignupPopup extends HTMLElement {
  #timer = null;
  #ac = null;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.#ac = new AbortController();

    dialog.addEventListener('close', () => this.#remember(this.hasAttribute('subscribed') ? 'subscribed' : 'dismissed'), { signal: this.#ac.signal });

    if (this.hasAttribute('subscribed')) this.#remember('subscribed');

    if (this.hasAttribute('open-now')) {
      requestAnimationFrame(() => { if (!dialog.open) dialog.showModal(); });
      return;
    }

    if (this.#isSuppressed()) return;
    const delay = Number(this.getAttribute('delay') || 6000);
    this.#timer = setTimeout(() => { if (!dialog.open) dialog.showModal(); }, delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    this.#ac?.abort();
  }

  #isSuppressed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const state = JSON.parse(raw);
      if (state.status === 'subscribed') return true;
      return Date.now() - state.at < SUPPRESS_DAYS * 86400000;
    } catch {
      return false;
    }
  }

  #remember(status) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ status, at: Date.now() }));
    } catch {
      // Storage can be unavailable (private mode); the popup simply reappears next visit.
    }
  }
}

if (!customElements.get('s-signup-popup')) customElements.define('s-signup-popup', SSignupPopup);
